import StepCallout from './step-callout';

const CALLOUT_STEPS = [
  {
    label: 'Start broad',
    prompt: '“What is the biggest YoY change in my 2026 deposit pool?”',
  },
  {
    label: 'Add a filter',
    prompt:
      '“Where geographically is our largest YoY decline in deposit volume?”',
  },
  {
    label: 'Drill deeper',
    prompt: '“Break that down by income band.”',
  },
  {
    label: 'Turn insight into action',
    prompt: '“Which regions should we prioritize for travel this fall?”',
  },
];

const MarkWalkthroughStep2 = () => (
  <div className="flex-1 flex flex-col gap-4 pt-4">
    <div>
      <h2 className="text-xl font-bold text-gray-900">
        Dig deeper — one question leads to the next.
      </h2>
      <p className="mt-1 text-base text-gray-700">
        MARK holds the thread of your conversation. Each follow-up builds on the
        last — no need to repeat context or start over.
      </p>
    </div>

    <StepCallout steps={CALLOUT_STEPS} />

    <p className="text-base text-gray-700">
      Start broad, then narrow down to the insight that matters. Each answer
      opens the door to the next question.
    </p>
  </div>
);

export default MarkWalkthroughStep2;
